import React, { useState } from 'react'
import "./Question.css"
import kpiImage from "../../assets/ai-agents-in-your-business.svg"
import { FaChevronUp, FaChevronDown } from "react-icons/fa"

const Question = () => {
    const [activeIndex, setActiveIndex] = useState(0)

    const faqData = [
        {
            question: "Budget-Aware Automation",
            answer: "Agents optimize infra usage during remediation."
        },
        {
            question: "Tagging & Cost Compliance",
            answer: "Enforce tagging policies across environments."
        },
        {
            question: "Cloud Spend Reduction",
            answer: "Identify and eliminate waste in real time."
        }
    ]

    const toggleAnswer = (index) => {
        setActiveIndex(activeIndex === index ? null : index)
    }

    return (
        <section className='quesiton-answer-section'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 content-left'>
                        <div className='section-header'>
                            <h2>Bring Cost Awareness into Incident Management</h2>
                        </div>

                        <div className='question-answer'>
                            {faqData.map((faq, index) => (
                                <div key={index} className={`card-one ${activeIndex === index ? "active" : ""}`}>
                                    <div
                                        className="question-header"
                                        onClick={() => toggleAnswer(index)}
                                    >
                                        <h3>{faq.question}</h3>
                                        <span className="icon">
                                            {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                        </span>
                                    </div>
                                    <p
                                        ref={(el) => {
                                            if (el && activeIndex === index) {
                                                el.style.maxHeight = el.scrollHeight + "px";
                                            } else if (el) {
                                                el.style.maxHeight = "0px";
                                            }
                                        }}
                                        className={`answer ${activeIndex === index ? "open" : ""}`}
                                    >
                                        {faq.answer}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='col-12 col-sm-6 col-md-6 col-lg-6 image-right'>
                        <img src={kpiImage} alt="question-section-img" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Question
